/**
 * Teacherzone slider script
 */
class ME_TeacherzoneSlider {
	constructor(slider_container) {
		this.initState(slider_container);
	}

	initState(slider_container) {
		this.sliderSection = slider_container;
		this.slider = this.sliderSection.find('.slider');
		this.slides = this.slider.find('li');
		this.first = 0;
		this.second = 1;
		this.third = 2;
		this.last = this.slides.length - 1;
		this.controls = this.sliderSection.find('.controls');
		this.navigation = this.controls.find('.navigation');
		this.prev = this.controls.find('.prev');
		this.next = this.controls.find('.next');
		this.animationInProgress = false;

		if (this.sliderSection.length && this.slides.length > 1) {
			for (let i = 0; i < this.slides.length; i++) {
				this.navigation.append('<li></li>');
			}

			this.navigationItem = this.navigation.find('li');
			this.navigationItem.first().addClass('active');

			setTimeout(() => {
				this.initEvents();
			},0);
		} else {
			if(this.slides.length <= 1) {
				this.prev.addClass('is-hidden');
				this.next.addClass('is-hidden');
			}
		}
	}

	initEvents() {
		setTimeout(() => {
			this.startMotion();
		}, 500);

		this.next.on('click', () => {
			if (this.animationInProgress) {
				return;
			}

			this.slides.addClass('motion');
			this.navigationItem.removeClass('active');

			this.first = (this.first + 1) % this.slides.length;
			this.second = (this.second + 1) % this.slides.length;
			this.third = (this.third + 1) % this.slides.length;
			this.last = (this.last + 1) % (this.slides.length);

			this.navigationItem.eq(this.first).addClass('active');

			setTimeout(() => {
				this.animationInProgress = false;
				this.startMotion();
			}, 500);
		})

		this.prev.on('click', () => {
			if (this.animationInProgress) {
				return;
			}

			this.slides.addClass('motion');
			this.navigationItem.removeClass('active');
			setTimeout(() => {
				this.animationInProgress = false;
				this.startMotion();
			}, 500);

			this.first = (this.first - 1) % this.slides.length;
			this.second = (this.second - 1) % this.slides.length;
			this.third = (this.third - 1) % this.slides.length;
			this.last = (this.last - 1) % (this.slides.length);

			this.navigationItem.eq(this.first).addClass('active');
		})

		this.navigationItem.on('click', () => {
			this.changeSlide($(this).index());
		})

		this.slides.on('click', () => {
			if ($(this).hasClass('second') || $(this).hasClass('third')) {
				this.changeSlide($(this).index());
			}
		})

		this.sliderSection.find('.link.show-all').on('click', (e) => {
			e.preventDefault();
			this.sliderSection.toggleClass('show-all');
		})
	}

	changeSlide(index) {
		this.first = index;
		this.second = (this.first + 1) % (this.slides.length);
		this.third = (this.first + 2) % (this.slides.length);
		this.last = (this.first - 1) % (this.slides.length);

		this.slides.addClass('motion');
		this.navigationItem.removeClass('active')
		setTimeout(() => {
			this.animationInProgress = false;
			this.startMotion();
		}, 500);

		this.navigationItem.eq(this.first).addClass('active');
	}

	startMotion() {
		this.slides.removeClass('first second third last');
		this.slides.eq(this.first).addClass('first');
		this.slides.eq(this.second).addClass('second');
		if (this.slider.length > 2) {
			this.slides.eq(this.third).addClass('third');
		}
		this.slides.eq(this.last).addClass('last');

		setTimeout(() => {
			this.slides.removeClass('motion');
		},500);

	}
}
